import { render, staticRenderFns } from "./termAgreement.vue?vue&type=template&id=ea64f656&scoped=true&"
import script from "./termAgreement.vue?vue&type=script&lang=js&"
export * from "./termAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea64f656",
  null
  
)

export default component.exports